import request from '@/utils/request'

export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/basics/notice/save_or_update',
    method: 'post',
    data
  })
}
export function targetList(params) {
  return request({
    url: '/icps/system/sign/basics/notice/target_list',
    method: 'get',
    params
  })
}
/**分页获取通讯录数据 */
export function query_mail_list(data) {
  return request({
    url: '/base/system/app/client/query_mail_list',
    method: 'post',
    data
  })
}